import React from 'react';
import PropTypes from 'prop-types';
import CountryModel from 'src/common/models/l10n/CountryModel';
import FooterLinkModel from 'src/common/models/prismic/components/FooterLinkModel';

import './Linkset.scss';

const LinkSet = props => (
  <nav className="FooterLinks">
    <ul>
      {props.linkItems.map(item => (
        <li key={item.url}>
          <a
            href={item.url}
            className="FooterLinks__link"
            target={item.openInNewTab ? '_blank' : null}
            rel={!item.googleFollow ? 'nofollow noopener' : null}
            onClick={props.onTrackLink({
              category: 'Footer Navigation',
              action: props.linkSet.title,
              label: item.linkText,
              href: item.url,
            })}>
            <span className="FooterLinks__link-text">
              {item.linkText}
              {item.label && <span className="FooterLinks__label">{item.label}</span>}
            </span>
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

LinkSet.propTypes = {
  linkSet: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  linkItems: PropTypes.arrayOf(FooterLinkModel.propTypes).isRequired,
  country: CountryModel.propTypes.isRequired,
  onTrackLink: PropTypes.func.isRequired,
};

export default LinkSet;
